export enum WebCredentialView {
  Home = 0,
  About = 1,
  Setup = 2,
}
